import { ChainKey } from "@silo/types";

/**
 * When adding a new chain, make sure that the native currency decimals is 18.
 * Otherwise, that value needs to be dynamically injected into these
 * calculations.
 */
export const NATIVE_DECIMALS_GUARD: Record<ChainKey, true> = {
  ethereum: true,
  arbitrum: true,
  optimism: true,
  base: true,
  anvil: true,
  local: true,
};

export const NATIVE_DECIMALS = 18;
